import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FaNewspaper } from "react-icons/fa";
import { Dimmer, Divider, Form, Icon, Loader, Popup } from "semantic-ui-react";
import { HtmlRenderer, slugify } from "../../component/utility";


export const BlogList = () => {
    const dataArticle = useLocation().state
    const [article, setArticle] = useState([])
    const [loadData, setLoadData] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const url = "https://javabasketballasia.com/api_hoops_cms/controler/blog.php"
    const [notFound, setNotFound] = useState(false)

    const navigate = useNavigate()

    const getArticleData = async () => {
        setLoadData(true)
        await axios({
            method: "GET",
            url: url,
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => {
            if (res.data.state === 200) {
                let data = res.data.data
                const updatedData = data.map(item => {
                    const formattedDate = new Date(item.created_at).toLocaleDateString('en-US', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                    });

                    return {
                        ...item,
                        formatted_time: formattedDate,
                    };
                });

                setArticle(updatedData)
            } else {
                alert(res.data.message)
            }
        }).finally(() => {
            setLoadData(false)
            setNotFound(false)
        })
    }

    const handleClickArticle = (data) => { 
        const slug = slugify(data.title)
        navigate(`/article/${slug}`, { state: data })
    }

    const sanitizeInput = (input) => {
        return input
            .replace(/[<>]/g, '')           // Hapus kalo ada tag html
            .replace(/['"]/g, '')           // hilangin kutipan
            .trim()                         // hilangin spasi di awal ahir
    }

    const filterArticle = async () => {
        setLoadData(true)
        const safeSearchValue = sanitizeInput(searchValue)

        await axios({
            method: "GET",
            url: url,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                search: safeSearchValue
            }
        }).then(res => {
            if (res.data.state === 200) {
                if (res.data.data.length > 0) {
                    let data = res.data.data
                    const updatedData = data.map(item => {
                        const formattedDate = new Date(item.created_at).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                        });

                        return {
                            ...item,
                            formatted_time: formattedDate,
                        };
                    });
                    setArticle(updatedData)
                    setNotFound(false)
                } else {
                    setNotFound(true)
                    setArticle([])
                }
            } else {
                alert(res.data.message)
            }
        }).finally(() => setLoadData(false))
    }

    useEffect(() => {
        if (searchValue !== ''){
            filterArticle()
        } else {
            getArticleData()
            setNotFound(false)
        }
    }, [searchValue])

    useEffect(() => {
        document.title = 'News & Article'
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        getArticleData()
    }, [])

    return (
        <>
            <section style={{ marginTop: "7rem" }}>
                <Container>
                    <Dimmer active={loadData} inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                    <Row className="mb-2">
                        <Col md={12} className="text-start">
                            <div className="text-center fs-2"><FaNewspaper /></div>
                            <Divider horizontal><h1 className="fs-5">News & Article</h1></Divider>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xl={6} lg={6} md={10}>
                            <Form onSubmit={filterArticle}>
                                <Form.Group>
                                    <Form.Input
                                        width={10}
                                        placeholder="Search by Title | Description"
                                        value={searchValue}
                                        icon={{ onClick: (e) => filterArticle(), name: "search", link: true }}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-start mb-5"  >
                        {article.map((art, i) => (
                            <Col xl={4} lg={6} md={6} sm={12} className="text-start mb-5" key={i}>
                                <Image src={art.image_thumbnail} height={200} rounded fluid />
                                <div>
                                    <Popup content={art.title} trigger={
                                        <h1 className="fs-5 mt-2 mb-1 text-truncate">{art.title}</h1>
                                    } />
                                </div>
                                <div className="small text-muted mt-1 mb-1">Date : {art.formatted_time}</div>
                                <h2 className="fs-6 fw-light mt-1" ><HtmlRenderer htmlContent={art.description.slice(0, 150)}/> ... <span className="btn-link" style={{ cursor: 'pointer' }} onClick={() => handleClickArticle(art)}>read more</span></h2>
                                <div className="small text-muted mt-2" style={{ lineHeight: '0.5em' }}>Author : {art.author}</div>
                            </Col>
                        ))}
                        {
                            notFound && 
                            <Col xl={12} lg={12} md={12} sm={12} className="text-center mb-5" >
                                <div className="p-5">
                                    <Icon name="exclamation circle" color="orange"/>
                                    <div>Article not found...</div>
                                </div>
                            </Col>
                        }
                    </Row>
                </Container>
            </section>
        </>
    )
}